// custom-editor.js (corrigé pour canvas responsive / conteneur aspect-ratio)

window.TEXT_TEMPLATES = {
  Anniversaire: [
    "Joyeux anniversaire au meilleur des compagnons ! Une année de plus à tes côtés.",
    "Un an de plus de bêtises, de câlins et de bonheur. Merci d'être toi !",
    "C'est ta journée ! On espère que tu recevras plein de friandises et de gratouilles.",
    "Chaque jour passé avec toi est un cadeau. Bon anniversaire, [Nom] !",
    "Encore une bougie, mais toujours le même amour. Joyeux anniversaire !"
  ],

  Deuil: [
    "À jamais dans nos cœurs, tu laisses une empreinte indélébile.",
    "Merci pour toutes ces années de bonheur et de fidélité. Repose en paix, petit ange.",
    "Cours librement de l'autre côté du pont de l'arc-en-ciel. Tu nous manques déjà.",
    "Pour notre compagnon fidèle qui nous a tant appris sur l'amour inconditionnel.",
    "Même loin de nous, ton amour continue de veiller sur nos cœurs."
  ],

  Accueil: [
    "Bienvenue dans ta famille pour la vie ! On a tellement hâte de tout partager avec toi.",
    "Le début d'une grande aventure. Nous te promettons une vie remplie de caresses et de jeux.",
    "Adopté(e) et déjà tellement aimé(e). Bienvenue à la maison, [Nom] !",
    "Officiellement le nouveau chef de la maison. On t'aime déjà !",
    "Notre cœur s'agrandit aujourd'hui : bienvenue dans la famille, [Nom]."
  ]
};


document.addEventListener('DOMContentLoaded', () => {

  /* ===========================
     CONFIG
     =========================== */
  const TEMPLATES = window.TEMPLATES || {};
  const DEBUG_COORDS = true;


  /* ===========================
     DOM & STATE (guards)
     =========================== */
  const templateSelect = document.getElementById('template');
  const groupSelect = document.getElementById('groupCard');
  const imageInput = document.getElementById('image');
  const cropSource = document.getElementById('cropSource');
  const imageMask = document.getElementById('imageMask');
  const previewCanvas = document.getElementById('previewCanvas'); // used to draw background template
  const overlayName = document.getElementById('overlayName');
  const overlayDates = document.getElementById('overlayDates');
  const overlayMessage = document.getElementById('overlayMessage');
  const nameInput = document.getElementById('name');
  const datesInput = document.getElementById('dates');
  const messageInput = document.getElementById('message');
  const msgCount = document.getElementById('msgCount');
  const statusDiv = document.getElementById('status');
  const finalCanvas = document.getElementById('finalCanvas');
  const finalCtx = finalCanvas ? finalCanvas.getContext('2d') : null;

  const editor = document.getElementById('imageMask'); // ou wrapper principal

['touchstart', 'touchmove', 'touchend', 'gesturestart', 'gesturechange', 'gestureend']
  .forEach(evt => {
    editor.addEventListener(evt, e => {
      e.preventDefault();
    }, { passive: false });
  });


  if (!previewCanvas || !cropSource || !imageMask || !templateSelect) {
    console.error('❌ INIT STOPPÉ', {
      previewCanvas,
      cropSource,
      imageMask,
      templateSelect
    });
    return;
  }
  console.log('✅ INIT OK — custom-editor chargé');
  const previewCtx = previewCanvas.getContext('2d');

  /* Preview vs Real metrics (internal canvas resolution stays high for export) */
  const PREVIEW_W = 360; const PREVIEW_H = 640;   // logical preview target (for references)
  const REAL_W = 1080; const REAL_H = 1920;      // internal/resolution used for export & drawing

  let cropper = null;
  let cropperReady = false;
  let previewDebounceTimer = null;
  let originalImageDataUrl = null;   // pour l’export Sharp (HD)
  let previewImageOptimized = null; // pour Cropper (fluide)


const initialTemplate =
window.INIT_TEMPLATE &&
TEMPLATES[window.INIT_TEMPLATE]
  ? window.INIT_TEMPLATE
  : templateSelect.value || Object.keys(TEMPLATES)[0];
  renderTextSuggestions(groupSelect.value);


const card = {
  templateKey: initialTemplate,
  imageDataUrl: null,
  name: '',
  dates: '',
  message: '',
  textBaselines: {
    name: [],
    dates: [],
    message: []
  }
};

function renderTextSuggestions(group) {
  const container = document.getElementById('textSuggestions');
  if (!container) return;

  container.innerHTML = '';

  const templates = window.TEXT_TEMPLATES?.[group];
  if (!templates || !templates.length) return;

  templates.forEach(text => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'suggestion';
    btn.textContent = text;

    btn.addEventListener('click', () => {
      const name = document.getElementById('name')?.value || '';
      const finalText = text.replace(/\[Nom\]/g, name);
      const textarea = document.getElementById('message');
      textarea.value = finalText;
      textarea.dispatchEvent(new Event('input'));
    });

    container.appendChild(btn);
  });
}



function initTemplateFromUrl() {
const params = new URLSearchParams(window.location.search);
const templateFromUrl = params.get('template');

// si rien dans l’URL → on laisse la valeur par défaut
if (!templateFromUrl) return;

// si le template n'existe pas → on ignore
if (!window.TEMPLATES || !window.TEMPLATES[templateFromUrl]) return;

// appliquer template
templateSelect.value = templateFromUrl;
card.templateKey = templateFromUrl;
}

console.log(window.TEMPLATES)

  let previewImageDataUrl = null;

  /* ===========================
     HELPERS
     =========================== */

     function loadGoogleFont(fontName) {
  const familyParam = fontName.replace(/ /g, '+');
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${familyParam}&display=swap`;
  document.head.appendChild(link);
  return document.fonts.load(`1em ${fontName}`);
}

    function applyOverlayFont(el, fontStr) {
  const font = parseFont(fontStr); // { weight, sizePx, family }
  el.style.fontFamily = font.family;
  el.style.fontWeight = font.weight;
  el.style.fontSize = `${Math.round(font.sizePx * currentDisplayScale())}px`;
}
     
  function updateTemplateInUrl(templateKey) {
    const url = new URL(window.location.href);
    url.searchParams.set('template', templateKey);
    window.history.replaceState({}, '', url);
  }

  function parseFont(fontString, fallbackSize = 40) {
    return {
      weight: parseInt(fontString.match(/^\d+/)?.[0] || '400', 10),
      sizePx: parseInt(fontString.match(/(\d+)px/)?.[1] || fallbackSize, 10),
      family: fontString.replace(/^\d+\s+\d+px\s*/, '').trim()
    };
  }


  function applySvgMask(imageMask, zone) {
    const svg = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="${zone.viewBox}">
    <path d="${zone.path}" fill="white"/>
  </svg>`;

    const encoded = encodeURIComponent(svg)
      .replace(/'/g, "%27")
      .replace(/"/g, "%22");

    const url = `url("data:image/svg+xml;utf8,${encoded}")`;

    imageMask.style.webkitMaskImage = url;
    imageMask.style.maskImage = url;
  }

  function setStatus(msg, isError = false){
    if (!statusDiv) return;
    statusDiv.textContent = msg || '';
    statusDiv.style.color = isError ? '#d9534f' : '#5cb85c';
  }

  /* compute the displayed scale (rendered canvas width / real internal width) */
  function currentDisplayScale(){
    // previewCanvas clientWidth is the actual CSS-rendered width
    const w = previewCanvas.clientWidth || PREVIEW_W;
    return w / REAL_W;
  }

  /* Convert template image zone (ratios) to real pixel rect on REAL canvas */
function zoneRealPixels(template){
const z = template.imageZone;
return {
  x: Math.round(z.x * REAL_W),
  y: Math.round(z.y * REAL_H),
  width: Math.round(z.width * REAL_W),
  height: Math.round(z.height * REAL_H),
  type: z.type,
  shape: z.shape,
  path: z.path,
  viewBox: z.viewBox
};
}

  /* Convert zone to preview/display pixel rect (based on current display scale) */
  function zonePreviewPixels(template){
    const zp = zoneRealPixels(template);
    const s = currentDisplayScale();
    return {
      x: Math.round(zp.x * s),
      y: Math.round(zp.y * s),
      width: Math.round(zp.width * s),
      height: Math.round(zp.height * s),
      shape: zp.shape
    };
  }

  function loadOptimizedImage(file, maxSize = 2000) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;

      // Calcul du ratio de redimensionnement
      if (width > height && width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      } else if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      // Qualité 0.9 = quasi identique visuellement
      const optimizedSrc = canvas.toDataURL("image/jpeg", 0.9);
      resolve(optimizedSrc);
    };

    img.src = URL.createObjectURL(file);
  });
}


  /* ===========================
     Draw template background with cover-fit (Returns a Promise)
     Draw on internal resolution (REAL_W x REAL_H) for quality, browser will scale it
     =========================== */
  function drawTemplateBackground(){
    const t = TEMPLATES[card.templateKey];
    
    return new Promise(resolve => {
      if (!t || !t.bg) {
        // blank
        previewCtx.clearRect(0,0,REAL_W,REAL_H);
        previewCtx.fillStyle = '#fff';
        previewCtx.fillRect(0,0,REAL_W,REAL_H);
        resolve();
        return;
      }

      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = t.bg;

      img.onload = () => {
        // draw cover: compute cover-fit on REAL canvas
        previewCtx.clearRect(0,0,REAL_W,REAL_H);

        const arImg = img.width / img.height;
        const arCanvas = REAL_W / REAL_H;
        let dw, dh, dx, dy;

        if (arImg > arCanvas) {
          // image wider -> fit height, crop sides
          dh = REAL_H;
          dw = Math.round(dh * arImg);
          dx = Math.round((REAL_W - dw) / 2);
          dy = 0;
        } else {
          // image taller -> fit width, crop top/bottom
          dw = REAL_W;
          dh = Math.round(dw / arImg);
          dx = 0;
          dy = Math.round((REAL_H - dh) / 2);
        }

        previewCtx.drawImage(img, dx, dy, dw, dh);
        resolve();
      };

      img.onerror = () => {
        previewCtx.clearRect(0,0,REAL_W,REAL_H);
        previewCtx.fillStyle = '#fff';
        previewCtx.fillRect(0,0,REAL_W,REAL_H);
        resolve();
      };
    });
  }

  /* ===========================
     Full redraw of preview
     =========================== */
  async function redrawPreview(){
    await drawTemplateBackground();


    // position image mask (uses display pixels)
    positionImageMask();

    // update text overlays
    refreshTextOverlays();



    // reset mask background & source visibility
    imageMask.style.backgroundImage = '';
    cropSource.style.opacity = '1';
    cropSource.style.display = 'block';

    if (card.imageDataUrl) {
      // ensure image element src is set (will trigger cropper init onload)
      cropSource.src = card.imageDataUrl;
      // If the image is already loaded in the element, init immediately
      if (cropSource.complete && cropSource.naturalWidth) {
        initCropper();
      }
      // otherwise initCropper will be triggered by cropSource.onload handler in image change flow
    }
  }

/* Position and size the interactive imageMask according to template zone (display pixels) */
function positionImageMask(){
const t = TEMPLATES[card.templateKey];
if (!t) return;

const zp = zonePreviewPixels(t);
const z = t.imageZone;

/* ===========================
   POSITION & SIZE (NE PAS SUPPRIMER)
   =========================== */
imageMask.style.left = `${zp.x}px`;
imageMask.style.top = `${zp.y}px`;
imageMask.style.width = `${zp.width}px`;
imageMask.style.height = `${zp.height}px`;

/* ===========================
   RESET SHAPE
   =========================== */
imageMask.classList.remove('oval', 'svg');
imageMask.style.maskImage = '';
imageMask.style.webkitMaskImage = '';

/* ===========================
   APPLY SHAPE
   =========================== */
if (z.type === 'svg') {
  imageMask.classList.add('svg');
  applySvgMask(imageMask, z);
}
else if (z.shape === 'oval') {
  imageMask.classList.add('oval');
}
}

/* Initialize or re-init cropper on cropSource */
function initCropper(){

const t = TEMPLATES[card.templateKey];
if (!t) return;

const zp = zonePreviewPixels(t);

if (cropper) {
  try { cropper.destroy(); } catch(e){}
  cropper = null;
}
cropperReady = false;

// cropSource sized to preview mask
cropSource.style.width = `${zp.width}px`;
cropSource.style.height = `${zp.height}px`;

cropper = new Cropper(cropSource, {
  viewMode: 0,
  background: false,
  movable: true,
  zoomable: true,
  rotatable: false,
  scalable: false,
  dragMode: 'move',
  aspectRatio: zp.width / zp.height || (REAL_W / REAL_H),
  autoCrop: true,
  autoCropArea: 1,
  cropBoxMovable: false,
  cropBoxResizable: false,
  guides: false,
  highlight: false,
  center: true,
  toggleDragModeOnDblclick: false,

  // called once when image is ready
  ready() {
    cropperReady = true;
    setStatus(""); // 🔑 efface le message
    debouncedPreviewUpdate();
  },

  // called on EVERY zoom / move / drag
  crop() {
    debouncedPreviewUpdate();
  },

    zoom(event) {

    const MAX_ZOOM = 1.3;

    if (event.detail.ratio > MAX_ZOOM) {
      event.preventDefault();
      this.cropper.zoomTo(MAX_ZOOM);
    }
  }
});
}

  /* Debounced preview update */
let lastUpdate = 0;

function debouncedPreviewUpdate() {

  updateLiveImagePreview();
}
  /* Update the image visually inside mask for live preview:
     ask cropper for a cropped canvas sized to the DISPLAYED mask size
  */
function updateLiveImagePreview(){
if (!cropper) return;

try {
  const t = TEMPLATES[card.templateKey];
  if (!t) return;

  const zpDisplay = zonePreviewPixels(t);
const MAX_PREVIEW = 400;

const previewW = Math.min(MAX_PREVIEW, Math.round(zpDisplay.width));
const previewH = Math.min(MAX_PREVIEW, Math.round(zpDisplay.height));

  const cropped = cropper.getCroppedCanvas({
    width: previewW,
    height: previewH,
    imageSmoothingQuality: 'high'
  });

  if (!cropped) return;

  previewImageDataUrl = cropped.toDataURL('image/png', 0.2);
  imageMask.style.backgroundImage = `url(${cropped.toDataURL('image/png')})`;

  // 🔑 UNIQUE rendu visible
  imageMask.style.backgroundImage = `url(${previewImageDataUrl})`;
  imageMask.style.backgroundSize = 'cover';
  imageMask.style.backgroundPosition = 'center';

  // 🔑 cropper invisible mais actif
  //cropSource.style.visibility = 'hidden';
  //cropSource.style.pointerEvents = 'none';

  // shape
  if (t.imageZone.shape === 'oval') imageMask.classList.add('oval');
  else imageMask.classList.remove('oval');

} catch (err) {
  console.warn('updateLiveImagePreview error', err);
}
}

function extractFontFamily(fontStr) {
return fontStr.replace(/^[\d\s.]+px\s*/i, '').trim();
}

function getCanvasTop() {
  const rect = previewCanvas.getBoundingClientRect();
  return rect.top;
}

function renderMultilineOverlay(el, text) {
  if (!el) return;

  el.innerHTML = '';

  const lines = (text || '').split('\n');

  lines.forEach(line => {
    const span = document.createElement('span');
    span.textContent = line;
    span.style.display = 'block';
    el.appendChild(span);
  });
}

function getBaselineY(span) {
  const rect = span.getBoundingClientRect();
  const style = window.getComputedStyle(span);
  const fontSize = parseFloat(style.fontSize);

  // ratio DOM stable
  const ascent = fontSize * 0.8;

  return rect.top + ascent;
}

function computeBaselines(el) {
  if (!el) return [];

  const spans = el.querySelectorAll('span');
  const scale = currentDisplayScale();
  const canvasTop = getCanvasTop();
  const baselines = [];

  spans.forEach(span => {
    const domY = getBaselineY(span);

    // 🔑 Y RELATIF AU CANVAS
    const relativeY = domY - canvasTop;

    // 🔑 conversion vers 1080×1920
    baselines.push(Math.round(relativeY / scale));
  });

  return baselines;
}


/* Refresh DOM overlays (texts) */
async function refreshTextOverlays(){

  function applyBaselineCorrection(el, fontPx) {
  const ascent = Math.round(0);
  el.style.transform = `translateY(+${ascent}px)`;

}

renderMultilineOverlay(overlayName, card.name);
renderMultilineOverlay(overlayDates, card.dates);
renderMultilineOverlay(overlayMessage, card.message);


const t = TEMPLATES[card.templateKey];
if (!t) return;

const displayScale = currentDisplayScale();

const namePx = parseInt((t.nameFont.match(/(\d+)px/) || [,'40'])[1], 10);
const datesPx = parseInt((t.datesFont.match(/(\d+)px/) || [,'20'])[1], 10);
const msgPx = parseInt((t.messageFont.match(/(\d+)px/) || [,'18'])[1], 10);

/* tailles */
if (overlayName) overlayName.style.fontSize = `${Math.round(namePx * displayScale)}px`;
if (overlayDates) overlayDates.style.fontSize = `${Math.round(datesPx * displayScale)}px`;
if (overlayMessage) overlayMessage.style.fontSize = `${Math.round(msgPx * displayScale)}px`;

/* couleurs */
if (overlayName) overlayName.style.color = t.nameColor;
if (overlayDates) overlayDates.style.color = t.datesColor;
if (overlayMessage) overlayMessage.style.color = t.messageColor;

  await loadGoogleFont(extractFontFamily(t.nameFont));
  await loadGoogleFont(extractFontFamily(t.datesFont));
  await loadGoogleFont(extractFontFamily(t.messageFont));

  /* polices 🔑 */
  if (overlayName) applyOverlayFont(overlayName, t.nameFont);
  if (overlayDates) applyOverlayFont(overlayDates, t.datesFont);
  if (overlayMessage) applyOverlayFont(overlayMessage, t.messageFont);

/* positions */
if (overlayName) overlayName.style.bottom = `${Math.round((1 - t.nameY) * 100)}%`;
applyBaselineCorrection(overlayName, datesPx * displayScale);
if (overlayDates) overlayDates.style.bottom = `${Math.round((1 - t.datesY) * 100)}%`;
applyBaselineCorrection(overlayDates, datesPx * displayScale);
if (overlayMessage) overlayMessage.style.bottom = `${Math.round((1 - t.messageY) * 100)}%`;
applyBaselineCorrection(overlayMessage, datesPx * displayScale);

// 🔥 CALCUL DES BASELINES RÉELLES POUR SHARP
card.textBaselines.name = computeBaselines(overlayName);
card.textBaselines.dates = computeBaselines(overlayDates);
card.textBaselines.message = computeBaselines(overlayMessage);


}


  /* ===========================
     EVENTS
     =========================== */

  // watch resize so mask/overlay update when previewFrame resizes
  const ro = new ResizeObserver(() => {
    positionImageMask();
    refreshTextOverlays();
    debouncedPreviewUpdate();
  });
  ro.observe(previewCanvas);

  groupSelect.addEventListener('change', e => {
  const group = e.target.value;
  renderTextSuggestions(group);
});

  templateSelect.addEventListener('change', () => {
    card.templateKey = templateSelect.value;
    updateTemplateInUrl(card.templateKey);
    redrawPreview();
  });

if (imageInput) {
imageInput.addEventListener('change', (ev) => {
  const f = ev.target.files && ev.target.files[0];
  if (!f) return;

  const reader = new FileReader();

  reader.onload = (e) => {
    card.imageDataUrl = e.target.result;

    // 🔑 reset état visuel
    imageMask.style.backgroundImage = 'none';
    imageMask.classList.remove('has-image');

    // 🔑 image source invisible mais présente
    cropSource.src = card.imageDataUrl;
    cropSource.style.opacity = '0';
    cropSource.style.pointerEvents = 'auto';

    cropSource.onload = async () => {

      console.log("📷 Image chargée");

      // 🔑 FORCER l'init du cropper ici
      if (!cropper) {
        initCropper();
      } else {
        cropper.replace(card.imageDataUrl, false);
      }

      imageMask.classList.add('has-image');

      // redraw purement visuel (ne doit plus toucher au cropper)
      await redrawPreview();

      cropSource.onload = null;
    };


    cropSource.onerror = () => {
      setStatus('Erreur lors du chargement de l\'image.', true);
      cropSource.onload = null;
    };
  };

  reader.readAsDataURL(f);
});
}

  if (nameInput) {
    nameInput.addEventListener('input', (e) => {
      card.name = e.target.value.slice(0,30);
      refreshTextOverlays();
    });
  }
  if (datesInput) {
    datesInput.addEventListener('input', (e) => {
      card.dates = e.target.value.slice(0,30);
      refreshTextOverlays();
    });
  }
  if (messageInput) {
    messageInput.addEventListener('input', (e) => {
      card.message = e.target.value.slice(0,140);
      if (msgCount) msgCount.textContent = `${card.message.length} / 400`;
      refreshTextOverlays();
    });
  }

  /* ===========================
     EXPORT (final canvas 1080x1920)
     =========================== */

async function exportFinalImage() {
console.log('🚀 exportFinalImage START');

/* ===========================
   VALIDATIONS
   =========================== */
const t = TEMPLATES[card.templateKey];
if (!t) {
  console.error('❌ TEMPLATE INVALID');
  setStatus('Template invalide.', true);
  return null;
}

if (!card.name && !card.dates && !card.message) {
  console.warn('⚠️ NO TEXT PROVIDED');
  setStatus('Veuillez saisir au moins un texte.', true);
  return null;
}

setStatus('Préparation de l’image…');

/* ===========================
   INIT FINAL CANVAS
   =========================== */
console.log('🧼 INIT CANVAS');
finalCanvas.width = REAL_W;
finalCanvas.height = REAL_H;
finalCtx.clearRect(0, 0, REAL_W, REAL_H);

/* ===========================
   DRAW TEMPLATE BACKGROUND
   =========================== */
console.log('🧱 DRAW BACKGROUND');

if (t.bg) {
  await new Promise((resolve) => {
    const bgImg = new Image();
    bgImg.crossOrigin = 'anonymous';
    bgImg.src = t.bg;

    bgImg.onload = () => {
      const arImg = bgImg.width / bgImg.height;
      const arCanvas = REAL_W / REAL_H;

      let dw, dh, dx, dy;

      if (arImg > arCanvas) {
        dh = REAL_H;
        dw = dh * arImg;
        dx = -(dw - REAL_W) / 2;
        dy = 0;
      } else {
        dw = REAL_W;
        dh = dw / arImg;
        dx = 0;
        dy = -(dh - REAL_H) / 2;
      }

      finalCtx.drawImage(bgImg, dx, dy, dw, dh);
      console.log('✅ BACKGROUND DRAWN');
      resolve();
    };

    bgImg.onerror = () => {
      console.error('❌ BG LOAD ERROR');
      finalCtx.fillStyle = '#fff';
      finalCtx.fillRect(0, 0, REAL_W, REAL_H);
      resolve();
    };
  });
} else {
  finalCtx.fillStyle = '#fff';
  finalCtx.fillRect(0, 0, REAL_W, REAL_H);
}

/* ===========================
   DRAW TEXTS
   =========================== */
console.log('✏️ DRAW TEXTS');

finalCtx.textAlign = 'center';
finalCtx.textBaseline = 'middle';

if (card.name) {
  finalCtx.fillStyle = t.nameColor;
  finalCtx.font = t.nameFont;
  finalCtx.fillText(
    card.name,
    REAL_W / 2,
    Math.round(REAL_H * t.nameY)
  );
}

if (card.dates) {
  finalCtx.fillStyle = t.datesColor;
  finalCtx.font = t.datesFont;
  finalCtx.fillText(
    card.dates,
    REAL_W / 2,
    Math.round(REAL_H * t.datesY)
  );
}

if (card.message) {
  finalCtx.fillStyle = t.messageColor;
  finalCtx.font = t.messageFont;

  const maxWidth = Math.round(REAL_W * 0.75);
  const lineHeight =
    parseInt(t.messageFont.match(/(\d+)px/)?.[1] || 28, 10) + 6;

  wrapText(
    finalCtx,
    card.message,
    REAL_W / 2,
    Math.round(REAL_H * t.messageY),
    maxWidth,
    lineHeight
  );
}

/* ===========================
   EXPORT
   =========================== */
const dataUrl = finalCanvas.toDataURL('image/jpeg', 0.92);
console.log('✅ EXPORT DONE');

setStatus('Image générée.');
return dataUrl;
}

  /* simple multiline text wrapper drawing centered */
  function wrapText(ctx, text, x, y, maxWidth, lineHeight){
    if (!text) return;
    const words = text.split(' ');
    let line = '';
    const lines = [];
    for (let n=0;n<words.length;n++){
      const test = line + (line ? ' ' : '') + words[n];
      const m = ctx.measureText(test);
      if (m.width > maxWidth && line){
        lines.push(line);
        line = words[n];
      } else {
        line = test;
      }
    }
    if (line) lines.push(line);
    const visible = lines.slice(0,6);
    for (let i=0;i<visible.length;i++){
      ctx.fillText(visible[i], x, y + i*lineHeight);
    }
  }

  /* ===========================
     INIT
     =========================== */

  function init(){
    // set internal canvas resolution (high-res for export).
    previewCanvas.width = REAL_W;
    previewCanvas.height = REAL_H;
    initTemplateFromUrl();
    if (finalCanvas) {
      finalCanvas.width = REAL_W;
      finalCanvas.height = REAL_H;
    }

    // initial draw
    redrawPreview();

    // wheel on mask to zoom
    imageMask.addEventListener('wheel', (e) => {
      if (!cropper) return;
      e.preventDefault();
      const delta = -e.deltaY;
      if (delta > 0) cropper.zoom(0.05); else cropper.zoom(-0.05);
    }, { passive: false });
  }

  init();

  (function forceReloadOnBack() {
  // Cas 1 : Page restaurée depuis le cache navigateur (bfcache)
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      console.log("🔄 bfcache détecté → reload forcé");
      window.location.reload();
    }
  });

  // Cas 2 : Fallback Safari / Chrome (quand persisted n’est pas fiable)
  const nav = performance.getEntriesByType("navigation")[0];
  if (nav && nav.type === "back_forward") {
    console.log("🔄 back_forward détecté → reload forcé");
    window.location.reload();
  }
})();


  // Expose export helper on window for debug (optional)
  window.__cardEditor = {
    exportFinalImage,
    extractSharpPayload
  };

function logFinalCardStructureExtreme() {
  const t = TEMPLATES[card.templateKey];

  if (!t) {
    console.error('❌ TEMPLATE INTROUVABLE');
    return;
  }

  if (!cropper || !card.imageDataUrl) {
    console.error('❌ IMAGE OU CROPPER MANQUANT');
    return;
  }

  const imageData = cropper.getImageData();
  const cropData = cropper.getData(true);
  const displayScale = currentDisplayScale();

  /* ===========================
     TEMPLATE
     =========================== */
  console.group('🧩 TEMPLATE');
  console.log('Key', card.templateKey);
  console.log('Raw config', JSON.parse(JSON.stringify(t)));
  console.groupEnd();

  /* ===========================
     CANVAS FINAL
     =========================== */
  console.group('🖼️ CANVAS FINAL');
  console.log('Resolution', {
    width: REAL_W,
    height: REAL_H,
    aspectRatio: REAL_W / REAL_H
  });
  console.log('Rendering intent', {
    smoothing: true,
    interpolation: 'bicubic (browser dependent)',
    colorSpace: 'sRGB'
  });
  console.groupEnd();

  /* ===========================
     BACKGROUND
     =========================== */
  console.group('🧱 BACKGROUND');
  console.log('Source URL', t.bg || null);

  if (t.bg) {
    console.log('Cover-fit algorithm', {
      strategy: 'CSS background-size: cover (canvas equivalent)',
      cropAxis:
        (REAL_W / REAL_H) > 1
          ? 'vertical crop possible'
          : 'horizontal crop possible'
    });
  }

  console.log('Target size', {
    width: REAL_W,
    height: REAL_H
  });
  console.groupEnd();

  /* ===========================
     IMAGE UTILISATEUR (SOURCE)
     =========================== */
  console.group('📷 IMAGE UTILISATEUR — SOURCE');
  console.log('Data URL', {
    present: true,
    length: card.imageDataUrl.length,
    mime: card.imageDataUrl.substring(5, card.imageDataUrl.indexOf(';'))
  });
  console.log('Natural size', {
    width: Math.round(imageData.naturalWidth),
    height: Math.round(imageData.naturalHeight),
    aspectRatio: imageData.naturalWidth / imageData.naturalHeight
  });
  console.log('Displayed in cropper', {
    scaleX: imageData.scaleX,
    scaleY: imageData.scaleY,
    rotate: imageData.rotate
  });
  console.groupEnd();

  /* ===========================
     CROP (SOURCE SPACE)
     =========================== */
  console.group('✂️ CROP — SOURCE SPACE');
  console.log('Crop rect (natural pixels)', {
    x: Math.round(cropData.x),
    y: Math.round(cropData.y),
    width: Math.round(cropData.width),
    height: Math.round(cropData.height)
  });
  console.log('Crop ratios', {
    x: cropData.x / imageData.naturalWidth,
    y: cropData.y / imageData.naturalHeight,
    width: cropData.width / imageData.naturalWidth,
    height: cropData.height / imageData.naturalHeight
  });
  console.log('Aspect ratio', cropData.width / cropData.height);
  console.groupEnd();

  /* ===========================
     ZONE IMAGE (TARGET SPACE)
     =========================== */
  console.group('🎯 ZONE IMAGE — TARGET');
  console.log('Template ratios', t.imageZone);

  const target = {
    x: Math.round(t.imageZone.x * REAL_W),
    y: Math.round(t.imageZone.y * REAL_H),
    width: Math.round(t.imageZone.width * REAL_W),
    height: Math.round(t.imageZone.height * REAL_H)
  };

  console.log('Target pixels (final canvas)', target);
  console.log('Target aspect ratio', target.width / target.height);
  console.groupEnd();

  /* ===========================
     MASK
     =========================== */
  console.group('🎭 MASK');
  console.log('Type', t.imageZone.type || 'rect');
  console.log('Shape', t.imageZone.shape || 'rect');

  if (t.imageZone.type === 'svg') {
    console.log('SVG mask', {
      viewBox: t.imageZone.viewBox,
      path: t.imageZone.path,
      complexity: t.imageZone.path.length
    });
  }

  if (t.imageZone.shape === 'oval') {
    console.log('Oval mask', {
      implicit: 'ellipse fitting target rect',
      rx: target.width / 2,
      ry: target.height / 2
    });
  }
  console.groupEnd();

  /* ===========================
     PREVIEW / DISPLAY PIPELINE
     =========================== */
  console.group('🧪 PREVIEW PIPELINE');
  console.log('Preview canvas CSS scale', displayScale);
  console.log('Preview canvas internal', {
    width: previewCanvas.width,
    height: previewCanvas.height
  });
  console.log('Mask display rect', zonePreviewPixels(t));
  console.log('Live preview image', {
    generated: !!previewImageDataUrl,
    resolution: zonePreviewPixels(t)
  });
  console.groupEnd();

  /* ===========================
     CROPPER STATE
     =========================== */
  console.group('🧠 CROPPER STATE');
  console.log('Options', cropper.options);
  console.log('Image position', cropper.getImageData());
  console.log('Crop box locked', {
    movable: false,
    resizable: false
  });
  console.groupEnd();

  /* ===========================
     SUMMARY (ONE OBJECT)
     =========================== */
  console.group('📦 FINAL NON-TEXT PAYLOAD (SUMMARY)');
  console.log({
    template: card.templateKey,
    canvas: { width: REAL_W, height: REAL_H },
    background: t.bg || null,
    userImage: {
      width: imageData.naturalWidth,
      height: imageData.naturalHeight
    },
    crop: {
      x: cropData.x,
      y: cropData.y,
      width: cropData.width,
      height: cropData.height
    },
    target,
    mask: t.imageZone
  });
  console.groupEnd();

  console.info('✅ LOGGING COMPLET TERMINÉ');
}

function logFinalCardStructure_1080x1920() {
  const t = TEMPLATES[card.templateKey];
  if (!t || !cropper) {
    console.error('❌ Template ou cropper manquant');
    return;
  }

  /* ===========================
     CONSTANTES
     =========================== */
  const FINAL_W = REAL_W; // 1080
  const FINAL_H = REAL_H; // 1920

  /* ===========================
     IMAGE SOURCE (NATURELLE)
     =========================== */
  const imageData = cropper.getImageData();
  const cropData  = cropper.getData(true);

  /* ===========================
     ZONE IMAGE FINALE
     =========================== */
  const target = {
    x: Math.round(t.imageZone.x * FINAL_W),
    y: Math.round(t.imageZone.y * FINAL_H),
    width:  Math.round(t.imageZone.width  * FINAL_W),
    height: Math.round(t.imageZone.height * FINAL_H)
  };

  /* ===========================
     FACTEURS DE PROJECTION
     =========================== */
  const scaleToFinal = {
    x: target.width  / cropData.width,
    y: target.height / cropData.height
  };

  console.group('🖼️ CARTE FINALE — RÉFÉRENTIEL UNIQUE 1080×1920');

  /* ===========================
     CANVAS FINAL
     =========================== */
  console.group('📐 CANVAS FINAL');
  console.log({
    width: FINAL_W,
    height: FINAL_H,
    aspectRatio: FINAL_W / FINAL_H
  });
  console.groupEnd();

  /* ===========================
     IMAGE UTILISATEUR — SOURCE
     =========================== */
  console.group('📷 IMAGE SOURCE (NATURELLE)');
  console.log({
    width: imageData.naturalWidth,
    height: imageData.naturalHeight,
    aspectRatio: imageData.naturalWidth / imageData.naturalHeight
  });
  console.groupEnd();

  /* ===========================
     CROP — EXPRIMÉ EN FINAL PX
     =========================== */
  console.group('✂️ CROP (PROJETÉ EN 1080×1920)');

  const cropFinalSpace = {
    x: Math.round((cropData.x / cropData.width) * target.width + target.x),
    y: Math.round((cropData.y / cropData.height) * target.height + target.y),
    width: target.width,
    height: target.height
  };

  console.log({
    sourceCrop: {
      x: Math.round(cropData.x)*scaleToFinal.x,
      y: Math.round(cropData.y)*scaleToFinal.y,
      width: Math.round(cropData.width),
      height: Math.round(cropData.height)
    },
    projectedInFinalCanvas: cropFinalSpace,
    scaleApplied: scaleToFinal
  });

  console.groupEnd();

  /* ===========================
     ZONE IMAGE (TARGET)
     =========================== */
  console.group('🎯 ZONE IMAGE — FINAL');
  console.log({
    x: target.x,
    y: target.y,
    width: target.width,
    height: target.height,
    aspectRatio: target.width / target.height
  });
  console.groupEnd();

  /* ===========================
     MASK
     =========================== */
  console.group('🎭 MASQUE');
  console.log({
    type: t.imageZone.type || 'rect',
    shape: t.imageZone.shape || 'rect',
    svg:
      t.imageZone.type === 'svg'
        ? {
            viewBox: t.imageZone.viewBox,
            pathLength: t.imageZone.path.length
          }
        : null
  });
  console.groupEnd();

  /* ===========================
     OVERFLOW — INTERPRÉTATION
     =========================== */
  console.group('📊 INTERPRÉTATION GÉOMÉTRIQUE');

  const imageAspect  = imageData.naturalWidth / imageData.naturalHeight;
  const targetAspect = target.width / target.height;

  console.log({
    imageAspect,
    targetAspect,
    overflowExpected: {
      horizontal: imageAspect > targetAspect,
      vertical: imageAspect < targetAspect
    },
    fillStrategy: 'cover'
  });

  console.groupEnd();

console.group('🧩 IMAGE UTILISATEUR — DIMENSION FINALE (1080×1920)');

const zoneAspect   = cropFinalSpace.width / cropFinalSpace.height;

let finalImageWidth, finalImageHeight;

if (imageAspect > zoneAspect) {

  if(scaleToFinal.x < 1){
  finalImageHeight = Math.round(imageData.naturalHeight) * scaleToFinal.x;
  finalImageWidth  = Math.round(imageData.naturalHeight) * imageAspect * scaleToFinal.y;
  } else{
    finalImageHeight = Math.round(imageData.naturalHeight) * scaleToFinal.x;
    finalImageWidth  = Math.round(imageData.naturalHeight) * imageAspect * scaleToFinal.y;
  }

} else {
  if(scaleToFinal.x < 1){
  // overflow vertical
  finalImageWidth  = Math.round(imageData.naturalWidth) * scaleToFinal.x;
  finalImageHeight = Math.round(imageData.naturalWidth) / imageAspect * scaleToFinal.y;
} else {
  finalImageWidth  = Math.round(imageData.naturalWidth) * scaleToFinal.x;
  finalImageHeight = Math.round(imageData.naturalWidth) / imageAspect * scaleToFinal.y;
}
}

console.log({
  width: finalImageWidth,
  height: finalImageHeight,
  aspectRatio: imageAspect,
  coordinates: {
    x: Math.round(cropData.x)*scaleToFinal.x,
    y: Math.round(cropData.y)*scaleToFinal.y
  },
});

console.groupEnd();

  console.groupEnd();
  console.info('✅ LOG 100 % NORMALISÉ EN 1080×1920 TERMINÉ');
}


function extractSharpPayload() {
  const t = TEMPLATES[card.templateKey];
  if (!t) {
    throw new Error('Template invalide');
  }

  if (!card.imageDataUrl) {
    throw new Error('Image utilisateur ou cropper manquant');
  }

  if (!cropper) {
    throw new Error('Cropper non initialisé');
  }

  if (!cropperReady) {
    throw new Error('Cropper pas encore prêt');
  }


/* ===========================
   IMAGE UTILISATEUR
   =========================== */

  const FINAL_W = REAL_W; // 1080
  const FINAL_H = REAL_H; // 1920

const imageData = cropper.getImageData();
const cropData = cropper.getData(true);

  const target = {
    x: Math.round(t.imageZone.x * FINAL_W),
    y: Math.round(t.imageZone.y * FINAL_H),
    width:  Math.round(t.imageZone.width  * FINAL_W),
    height: Math.round(t.imageZone.height * FINAL_H)
  };

  /* ===========================
     FACTEURS DE PROJECTION
     =========================== */
  const scaleToFinal = {
    x: target.width  / cropData.width,
    y: target.height / cropData.height
  };

  const cropFinalSpace = {
    x: Math.round((cropData.x / cropData.width) * target.width + target.x),
    y: Math.round((cropData.y / cropData.height) * target.height + target.y),
    width: target.width,
    height: target.height
  };

const imageAspect  = imageData.naturalWidth / imageData.naturalHeight;
const zoneAspect   = cropFinalSpace.width / cropFinalSpace.height;

let finalImageWidth, finalImageHeight;

if (imageAspect > zoneAspect) {

  if(scaleToFinal.x < 1){
  finalImageHeight = Math.round(imageData.naturalHeight) * scaleToFinal.x;
  finalImageWidth  = Math.round(imageData.naturalHeight) * imageAspect * scaleToFinal.y;
  } else{
    finalImageHeight = Math.round(imageData.naturalHeight) * scaleToFinal.x;
    finalImageWidth  = Math.round(imageData.naturalHeight) * imageAspect * scaleToFinal.y;
  }

} else {
  if(scaleToFinal.x < 1){
  // overflow vertical
  finalImageWidth  = Math.round(imageData.naturalWidth) * scaleToFinal.x;
  finalImageHeight = Math.round(imageData.naturalWidth) / imageAspect * scaleToFinal.y;
} else {
  finalImageWidth  = Math.round(imageData.naturalWidth) * scaleToFinal.x;
  finalImageHeight = Math.round(imageData.naturalWidth) / imageAspect * scaleToFinal.y;
}
}


const userImage = {
  dataUrl: card.imageDataUrl,
  width: Math.round(imageData.naturalWidth),
  height: Math.round(imageData.naturalHeight),
  realSize : {
    width : finalImageWidth,
    height: finalImageHeight 
  },
  offset : {
    x: Math.round(cropData.x)*scaleToFinal.x,
    y: Math.round(cropData.y)*scaleToFinal.y
  }
};

/* ===========================
   CROP (image utilisateur)
   =========================== */

const crop = {
  x: Math.round(cropData.x),
  y: Math.round(cropData.y),
  width: Math.round(cropData.width),
  height: Math.round(cropData.height)
};


  /* ===========================
    TARGET (zone image finale)
    =========================== */

  const zone = t.imageZone;

  const imageZone = {
    x: zone.x,
    y: zone.y,
    width: zone.width,
    height: zone.height
  };

  /* ===========================
    MASK
    =========================== */

  let mask = null;

  if (zone.type === 'svg') {
    mask = {
      type: 'svg',
      path: zone.path,
      viewBox: zone.viewBox
    };
  } else if (zone.shape === 'oval') {
    mask = {
      type: 'oval'
    };
  }

  /* ===========================
    BACKGROUND
    =========================== */

  const background = {
    url: t.bg.startsWith('http') ? t.bg : `https:${t.bg}`,
    width: REAL_W,
    height: REAL_H
  };

  /* ===========================
    TEXTES (🔥 NOUVEAU)
    =========================== */

const texts = {
  name: {
    value: card.name || '',
    font: parseFont(t.nameFont, 80),
    color: t.nameColor,
    baselinesY: card.textBaselines.name
  },
  dates: {
    value: card.dates || '',
    font: parseFont(t.datesFont, 60),
    color: t.datesColor,
    baselinesY: card.textBaselines.dates
  },
  message: {
    value: card.message || '',
    font: parseFont(t.messageFont, 50),
    color: t.messageColor,
    baselinesY: card.textBaselines.message
  }
};


  /* ===========================
    PAYLOAD FINAL
    =========================== */

  const payload = {
    background,
    userImage,
    crop,
    mask,
    target,
    imageZone,
    texts,
    meta: {
      template: card.templateKey,
      renderSize: {
        width: REAL_W,
        height: REAL_H
      }
    }
  };

  console.log('📦 SHARP PAYLOAD', payload);
  
  return payload;
}

  document.getElementById('addToCart').addEventListener('click', async () => {
try {

    if (!card.imageDataUrl) {
      alert("Veuillez ajouter une image.");
      return;
    }

  if (!cropper || !cropperReady) {
    setStatus("L'image est encore en cours de chargement, veuillez patienter.", true);
    return;
  }

  const jpegBase64 = await window.__cardEditor.exportFinalImage();

  if (!jpegBase64 || !jpegBase64.startsWith('data:image/jpeg')) {
    throw new Error('Image JPEG invalide');
  }

  const payload = window.__cardEditor.extractSharpPayload();    
  //logFinalCardStructureExtreme()
  logFinalCardStructure_1080x1920()
  const uploadRes = await fetch('https://cardrender.onrender.com/render-card', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      fileName: `carte-${Date.now()}.jpg`,
      payload
    })
  });

  if (!uploadRes.ok) throw new Error('Upload échoué');

  const { imageId } = await uploadRes.json();

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: SHOPIFY_PRODUCT_VARIANT_ID,
        quantity: 1,
        properties: {
          "image_id": imageId
        }
      }]
    })
  });

window.location.href = '/cart';

} catch (err) {
  console.error(err);
  alert('Erreur lors de la création de la carte');
}
});


});